var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ImageUpload',{staticClass:"team-view-header-logo",attrs:{"disabled":_vm.disabled,"title":_vm.title},on:{"change":function($event){return _vm.$emit('change', $event)},"error":_vm.handleError},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var imageSrc = ref.imageSrc;
var chooseImage = ref.chooseImage;
return [_c('TeamLogo',{attrs:{"src":imageSrc || _vm.value,"alt":"","color":"second"},nativeOn:{"click":function($event){return chooseImage($event)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }